export var MonthId;
(function (MonthId) {
    MonthId[MonthId["prev"] = 1] = "prev";
    MonthId[MonthId["curr"] = 2] = "curr";
    MonthId[MonthId["next"] = 3] = "next";
})(MonthId || (MonthId = {}));
//# sourceMappingURL=month-id.enum.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-mydatepicker/dist/enums/month-id.enum.js
// module id = 429
// module chunks = 4